import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@/styles/global.css';
// dayjs prema zadanom poznaje samo 'en' — ostale lokale mora eksplicitno
// učitati prije poziva dayjs.locale(...) (vidi DatesProvider settings.locale
// niže), inače @mantine/dates tiho pada natrag na engleske nazive mjeseci/dana.
import 'dayjs/locale/hr';
import 'dayjs/locale/de';

import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';

import '@/i18n';
import '@/i18n/zodErrorMap';

import { NetworkStatusWatcher } from '@/components/common';
import { AuthProvider } from '@/features/auth/context/AuthContext';
import { router } from '@/router';
import { queryClient } from '@/store/queryClient';
import { cssVariablesResolver, localizedTheme } from '@/theme/theme';
import { currentLocale } from '@/utils/format';

export const App = () => {
  const { i18n } = useTranslation();
  const theme = useMemo(() => localizedTheme(currentLocale()), [i18n.language]);

  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider
        theme={theme}
        cssVariablesResolver={cssVariablesResolver}
        defaultColorScheme="light"
      >
        <DatesProvider settings={{ locale: i18n.language, firstDayOfWeek: 1 }}>
          <AuthProvider>
            <ModalsProvider>
              <Notifications position="bottom-center" />
              <NetworkStatusWatcher />
              <RouterProvider router={router} />
            </ModalsProvider>
          </AuthProvider>
        </DatesProvider>
      </MantineProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};
